// Handles inactive-account responses from the API.
// BE returns { success: false, message, data: { accountStatus } } for
// SUSPENDED / REMOVED / DELETED users (401 on protected routes like GET /user/profile).

export const INACTIVE_ACCOUNT_STATUSES = ["SUSPENDED", "REMOVED", "DELETED"];

const NOTICE_KEY = "accountStatusNotice";

const DEFAULT_MESSAGES = {
  SUSPENDED:
    "Your account has been suspended by your institution. Please contact your institution for help.",
  REMOVED:
    "You've been removed by your institution. Contact your institution if you'd like to be invited back.",
  DELETED: "This account has been deleted and can't be accessed.",
};

// Returns { status, message } when the error body carries an inactive accountStatus, else null.
export const getAccountStatusNotice = (errorBody) => {
  const status = errorBody?.data?.accountStatus;
  if (!INACTIVE_ACCOUNT_STATUSES.includes(status)) return null;
  return {
    status,
    message: errorBody?.message || DEFAULT_MESSAGES[status],
  };
};

// Notice for a status we already know (e.g. from a STUDENT_SUSPENDED / STUDENT_REMOVED notification).
// The notification's own text wins; the default is the same wording the API uses.
export const buildAccountStatusNotice = (status, message) => ({
  status,
  message: message || DEFAULT_MESSAGES[status],
});

// Persist the notice so the sign-in page can show it after the redirect.
export const saveAccountStatusNotice = (notice) => {
  try {
    sessionStorage.setItem(NOTICE_KEY, JSON.stringify(notice));
  } catch (_) {}
};

// Read and clear the stored notice (shown once).
export const consumeAccountStatusNotice = () => {
  try {
    const raw = sessionStorage.getItem(NOTICE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(NOTICE_KEY);
    const notice = JSON.parse(raw);
    return INACTIVE_ACCOUNT_STATUSES.includes(notice?.status) ? notice : null;
  } catch (_) {
    return null;
  }
};
